<div class="main">
    <div class="header">
      {{heading}}
      <i class="material-icons" (click)='closeDialog();'>clear</i>
    </div>
    <div class="section">
      <div class="unit">
        <div class="upload">
          {{fileHeading}} <sup style="color: #E54131;">*</sup> :
          <input #fileInput type="file" style="outline: none;" accept=".csv" name="csv" id="csv" (change)="fileChanged($event)">
          <br>
          <span class="csvOnly"> ( {{'MESSAGE.BULK_UPLOAD.MSG.CSV_ONLY' | translate}} ) </span>
        </div>
        <div class='download'>
          <a href="{{downloadURL}}" target="_blank" download="sample.csv"> {{'BULKUPLOAD.downloadSample' | translate}}</a>
        </div>
        <div class="submitButton" (click)="upload();">
          <div class="button">
            {{'BULKUPLOAD.submit' | translate}}
          </div>
        </div>
      </div>
    </div>
  </div>
  